import { TicketDetailsPage } from './TicketDetails'
import { TicketsViewType } from './TicketsViewType'

export const TicketComplianceDetails = (): JSX.Element => {
  return <TicketDetailsPage viewType={TicketsViewType.Compliance} />
}
